import { Ui16Check } from '@ids/react-icons';

type IconedListProps = {
  listItems: string[];
  theme?: string;
};

function IconedList({ listItems, theme }: IconedListProps) {
  return (
    <ul className="if flex flex-column gap-16 iconed-list">
      {listItems.map((item, index) => {
        return (
          <li key={index} className={`if typography paragraph small flex gap-4`}>
            {theme ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="icon"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2 12C2 13.9778 2.58649 15.9112 3.68531 17.5557C4.78412 19.2002 6.34591 20.4819 8.17317 21.2388C10.0004 21.9957 12.0111 22.1937 13.9509 21.8079C15.8907 21.422 17.6725 20.4696 19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8079 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17317C20.4819 6.3459 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2C9.34784 2 6.8043 3.05357 4.92894 4.92893C3.05357 6.8043 2 9.34784 2 12Z"
                  fill="#DDE4E6"
                  stroke="#DDE4E6"
                  strokeWidth="0.5"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.038 15.467L18.381 8.06699L18.613 8.29699L11.038 15.933L6.613 11.467L6.845 11.237L11.038 15.467Z"
                  fill="#35555C"
                  stroke="#35555C"
                  strokeWidth="0.75"
                />
              </svg>
            ) : (
              <Ui16Check className="if color-blue-400 mt-2" />
            )}
            {item}
          </li>
        );
      })}
    </ul>
  );
}

export default IconedList;
